import { useState } from "react";
import api from "../api/api";

function AddVendor() {
  const [open,     setOpen]     = useState(false);
  const [name,     setName]     = useState("");
  const [phone,    setPhone]    = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  const add = async () => {
    if (!name || !phone || !password) {
      setError("Please fill all fields");
      return;
    }
    setError(""); setLoading(true);
    try {
      await api.post("/admin/vendor", { name, phone, password });
      setName(""); setPhone(""); setPassword("");
      setOpen(false);
      window.location.reload();
    } catch {
      setError("Failed to add vendor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="section-hdr">
        <div className="section-hdr-title">Vendors</div>
        <button className="btn btn-primary" onClick={() => setOpen(!open)}>
          {open ? "✕ Cancel" : "＋ Add Vendor"}
        </button>
      </div>

      {open && (
        <div className="card mb-24">
          <div className="card-header">
            <div className="card-title">Add New Vendor</div>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-error mb-16">⚠ {error}</div>}
            <div className="form-grid">
              <div className="form-group">
                <label className="form-label">Full Name *</label>
                <input className="form-input" placeholder="Vendor name"
                  value={name} onChange={e => setName(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Phone Number *</label>
                <input className="form-input" placeholder="10-digit mobile"
                  value={phone} onChange={e => setPhone(e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Password *</label>
                <input className="form-input" type="password" placeholder="Set a password"
                  value={password} onChange={e => setPassword(e.target.value)} />
              </div>
            </div>
            <div className="flex-center gap-8 mt-16">
              <button className="btn btn-gold" onClick={add} disabled={loading}>
                {loading ? "Adding…" : "Add Vendor"}
              </button>
              <button className="btn btn-outline" onClick={() => { setOpen(false); setError(""); }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddVendor;
